export const environment = {
  production: false,
  // baseUrl: "https://production.wiyak.online/wfleet/",
  baseUrl: "https://production.wiyak.online/wifleet/V2/",
  // baseUrl: "https://api.wiyak.net/wifleet/",
  // baseUrl: "https://development.wiyakdelivery.com/wfleet/",

  baseUrlVrooom: "https://development.wiyakdelivery.com/vroom/",
  OSRMDockerUrl: "https://development.wiyakdelivery.com/openstreet/route/v1/driving/",
  apiKey: "AIzaSyDqXmysQZM8pNUVcU7BWmLE2GutPVcO9vc", // wiyaktechsuperstar1@gmail.com 

  // Producation-wfleet
  mqtt: {
    hostName: "mqttwifleet.wiyak.online",
    path: "/mqtt",
    protocol: "wss",
    clean: true,
    connectTimeout: 4000,
    clientId: "wifleet_mqtt_" + Math.random().toString(16).substr(2, 10),
    userName: "WiFleet_prod",
    password: "LEJUwuJSMr6BYd1xoAH7Z60KjZImwmKCVhF32e0SNU2DQfYH4IxGLY",
    reconnectPeriod: 1000,
    keepalive: 65535
  },

  // Gulf-Bank
  // mqtt: {
  //   // hostName: "mqttwifleet.wiyak.online", //! Old
  //   hostName: "mqtt.wiyak.net", //! New
  //   path: "/mqtt",
  //   protocol: "wss",
  //   clean: true,
  //   connectTimeout: 4000,
  //   clientId: "wifleet_mqtt_" + Math.random().toString(16).substr(2, 10),
  //   userName: "WiFleet_prod",
  //   password: "LEJUwuJSMr6BYd1xoAH7Z60KjZImwmKCVhF32e0SNU2DQfYH4IxGLY",
  //   reconnectPeriod: 1000,
  //   keepalive: 65535
  // },

  // Development
  // mqtt: {
  //   hostName: "mqtt.wiyak.com",
  //   path: "/mqtt",
  //   protocol: "wss",
  //   clean: true,
  //   connectTimeout: 4000,
  //   clientId: "wfleetmqtt_" + Math.random().toString(16).substr(2, 10),
  //   userName: "wiyakkuwait",
  //   password: "0C46507DF16A0B4B4A25FC7FCC1D47B7wiyakkuwait",
  //   reconnectPeriod: 1000,
  //   keepalive: 65535
  // },


  // ForceApiKey: "ulO66nVd8zfrgfY172J*4iD+fh7K4Q+ZzxBhNiT2ld-JE7f5FvzMe$NeF55Bk35bza6NobTny57wiHF#ISNKBQU!KKwQC%H=yiGVPGtM1NoG*DYMAiIPVL&amp;9v$vO14SK",
  // ForceApiKey: "oZpbFohfTmx49EQdq4kk739QkVzfJprDxNaaPIbth8pNCaL2dMwqtU6iZok4cNNRNPPU4pquQZkxZyM2B0F4SianEcXwxjJuV6P6X3tMe5ccmfhpJ6GsPCNJ9wy2pR",
  // encryptSecretKey: "40770da6eaeb1d7e442f8b483fb49e088e72dc5113cb69637510553697035930",
  // ForceApiKey: "ulO66nVd8zfrgfY172J*4iD+fh7K4Q+ZzxBhNiT2ld-JE7f5FvzMe$NeF55Bk35bza6NobTny57wiHF#ISNKBQU!KKwQC%H=yiGVPGtM1NoG*DYMAiIPVL&amp;9v$vO14SK",
  
  //V2 
  ForceApiKey: "y00r68IjV9ZX2KalbOBm50jwjHJA1wa1wHPYogOtsks7f8ZV56cOdmJu83sj7SBJe4jFZ1OgZuh8n5Fub4zrhsSqODcyuWwZ4WB1OyKoOxkBgoBZSnGoJFgcsKEkWYHK",
  encryptSecretKey: "40770da6eaeb1d7e442f8b483fb49e088e72dc5113cb69637510553697035930",
  imageUrl: "media/img/fetch/",
  CompanySetting: "CompanySetting/",
  cars: "Car/",
  driver: "Driver/",
  DispatcherImg: "Dispatcher/",
  DispatcherCars: "DispatcherCars/",
  dashboardPageSplitterSize: {
    'dashboardMapPane': "65%",
    'dashboardTablePane': "35%",
  },

  driverMarkerIcon: {
    height: 60,
    width: 60,
    labelOrigin: { x: 0, y: -5 },
    anchor: { x: 50, y: 19 }
  },
  leafletMapKey: "pk.eyJ1IjoicmFrZXNodGlzIiwiYSI6ImNreHlhZHE0ajR3cXQydnF3MWJ5bmRoNnAifQ.Cy8QK8eNdoUA2_6mKJeslw",
  // ! Production Mode Delivery
  mapBox: {
    accessToken: [
      'pk.eyJ1IjoicnVwZW5td2l5YWsiLCJhIjoiY2xzNG9jamEwMWNzNzJrcXAwaXZ3eHcwZiJ9.P3SL9Pj5xEYn9GaziIWnNA',
      'pk.eyJ1Ijoia2hhbGVkd2l5YWsiLCJhIjoiY2xzNG9xNGhuMTNzaTJsb2V2d2d6bDJ5OSJ9.XkgeVZ0CyXLvVzNm7AHy6w'
    ]
  },

  // companyLogoBaseUrl: 'https://development.wiyakdelivery.com/wfleet/' + "media/img/fetch/" + "CompanySetting/",
  // favIconBaseUrl: 'https://development.wiyakdelivery.com/wfleet/' + "media/img/fetch/" + "CompanySetting/",
  
  companyLogoBaseUrl: 'https://production.wiyak.online/wifleet/' + "media/img/fetch/" + "CompanySetting/",
  favIconBaseUrl: 'https://production.wiyak.online/wifleet/' + "media/img/fetch/" + "CompanySetting/",

  // companyLogoBaseUrl: 'https://api.wiyak.net/wifleet/' + "media/img/fetch/" + "CompanySetting/",
  // favIconBaseUrl: 'https://api.wiyak.net/wifleet/' + "media/img/fetch/" + "CompanySetting/",
}